var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$store.state.user.langEng ? 'Page not found' : 'Sidan finns inte'))]),_c('br'),_c('p',[_vm._v(_vm._s(_vm.$store.state.user.langEng ? "Couldn't find page: " + _vm.url : 'Hittade inte sidan: ' + _vm.url))])])
}
var staticRenderFns = []

export { render, staticRenderFns }